import { getOnlineSitesV1 } from '../apis/sitesApi';
import { actionFactory } from '../infrastructure/actionFactory';

export const getOnlineSites = (cityId: string) =>
  actionFactory('ONLINE_SITES_GET', getOnlineSitesV1(cityId));
